class RefreshService {
  /**
   * @param {Object} store An object which will store the number of updates, and so on.
   */
  constructor(store) {
    // console.log("received store: " + store);
    if (arguments[1].length === 0)
      throw new Error('Keys not specified for refresh service')
    this._keys = [...arguments[1]]
    // console.log("received keys: " + JSON.stringify(this._keys));
    // initialize the snapshots store
    this._store = store
    // console.log(JSON.stringify(store));
    // console.log(JSON.stringify(this._store));
    this._keys.forEach((key) => {
      try {
        if (this._store[key] == null) {
          this._store[key] = {}
        }
        this._store[key].updates = 0
        this._store[key].updateKey = this.getUpdateKey(key)
      } catch (ex) {
        console.log('Could not initialize refresh store for key: ' + key)
        console.log(ex)
        throw ex
      }
    })
  }

  getUpdateKey(key) {
    if (this._store[key] == null) return null
    return `${key}--${this._store[key].updates}`
  }

  refresh(key) {
    if (this._store[key] == null) return
    this._store[key].updates++
    this._store[key].updateKey = this.getUpdateKey(key)
  }
}

export default RefreshService
